import { calculateFinances, UserData } from '../../../constants';

const DontDoFD = {
  label: 'Fixed Deposits',
  sections: [
    {
      type: 'text',
      text: (data: UserData) => {
        const taxData = calculateFinances(data);
        const fdInvested = Math.round(data.fd / 0.065 / 1000) * 1000;
        return `
        <br /><h5>Last year itself, you could've made up to Rs. ${(
          fdInvested * 0.18 -
          fdInvested * 0.05
        ).toLocaleString(
          'en-IN'
        )} more by choosing mutual funds instead of fixed deposits</h5>
        <br />
        <p>See how:</p>
        <table>
        <tr><td></td><td>Fixed Deposits</td><td>Mutual Funds</td></tr>
        <tr>
          <td>Approximate amount invested in FD in 17-18</td>
          <td>Rs. ${fdInvested.toLocaleString('en-IN')}</td>
          <td>Rs. ${fdInvested.toLocaleString('en-IN')}</td>
        </tr>
        <tr>
          <td>Fixed Deposit Returns you earned</td>
          <td>Rs. ${data.fd.toLocaleString('en-IN')}</td>
          <td>Rs. ${(fdInvested * 0.18).toLocaleString('en-IN')}</td>
        </tr>
        <tr>
          <td>After taxes of ${taxData.bracketPercent}%, you made</td>
          <td>Rs. ${(
            (data.fd * (100 - taxData.bracketPercent)) /
            100
          ).toLocaleString('en-IN')}</td>
          <td><small>0 tax till 1Lakh</small></td>
        </tr>
        <tr>
          <td>With inflation of 5% on Rs. ${fdInvested}, you made</td>
          <td>Rs. ${(
            (data.fd * (100 - taxData.bracketPercent)) / 100 -
            fdInvested * 0.05
          ).toLocaleString('en-IN')}</td>
          <td>Rs. ${(fdInvested * 0.18 - fdInvested * 0.05).toLocaleString(
            'en-IN'
          )}</td>
        </tr>
        </table>
        <br /><br />
        <h6>Don't worry. ClearTax can help you change this.<br />In the next step, we will show you how!</h6>
        `;
      },
    },
  ],
};

export default DontDoFD;



// WEBPACK FOOTER //
// ./components/recommendation/cards/dontDoFD.ts